import { render } from "./PlanAdd.vue?vue&type=template&id=43031d38&scoped=true"
import script from "./PlanAdd.vue?vue&type=script&lang=js"
export * from "./PlanAdd.vue?vue&type=script&lang=js"

import "./PlanAdd.vue?vue&type=style&index=0&id=43031d38&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43031d38"]])

export default __exports__